import { ReactElement } from "react";
import { LiveChatBlock } from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import { LiveChat } from "@twiliointernal/org/twilio/e2-commons/live-chat";

interface LiveChatBlockProps {
  block: LiveChatBlock;
}

const LiveChatRenderer = ({ block }: LiveChatBlockProps): ReactElement => {
  return <LiveChat {...block.values} />;
};

export default LiveChatRenderer;
